import React, { useState } from 'react';
import { Box, Checkbox, CircularProgress, FormControlLabel } from '@mui/material';
import { ReactComponent as UnCheckedIcon } from '../static/images/svg/material-symbols_check-box-outline-blank.svg';
import { ReactComponent as CheckedIcon } from '../static/images/svg/material-symbols_check-box-outline-rounded.svg';
import { COLOR_KEY, getModeColor } from '../themes/customization.value';
import { GetThemeMode } from '../themes/tool';


export type AsyncCheckboxWithLoadingProps = {
    checked: boolean;
    disabled?: boolean;
    label: React.ReactNode;
    onChange?: (checked: boolean) => void | Promise<void>;
};

/**
 * 通用异步勾选组件
 * - 支持异步 onChange，并在请求过程中自动进入 loading 禁用状态
 */
const AsyncCheckboxWithLoading: React.FC<AsyncCheckboxWithLoadingProps> = ({
    checked,
    disabled,
    label,
    onChange,
}) => {
    const [loading, setLoading] = useState(false);

    const handleChange = async (_event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
        if (disabled || loading) return;
        if (!onChange) return;
        setLoading(true);
        try {
            await onChange(value);
        } finally {
            setLoading(false);
        }
    };
    const themeMode = GetThemeMode();

    const getColor = (key: COLOR_KEY) => getModeColor(key, themeMode);

    return (
        <Box display='flex' alignItems='center'>
            <FormControlLabel
                control={
                    <Checkbox
                        disabled={disabled || loading}
                        checked={checked}
                        onChange={handleChange}
                        color='primary'
                        checkedIcon={<CheckedIcon />}
                        icon={(<UnCheckedIcon />)}
                        sx={{ color: getColor(COLOR_KEY.textPrimary300), py: 0 }}
                    />
                }
                label={label}
            />
            {loading && (
                <Box ml={1} display='flex' alignItems='center'>
                    <CircularProgress size={18} />
                </Box>
            )}
        </Box>
    );
};

export default AsyncCheckboxWithLoading;
